import { Product } from '../models/ApiModels'

export const sortUnitsNum = (products: Product[]): Product[] => products.sort((a: Product, b: Product): number =>
    parseFloat(a.name) - parseFloat(b.name)
)
